import { useTranslation } from "react-i18next";

export const useTran = (namespace = "common", options) =>
  useTranslation(namespace, options);
